(function() {
  const $imageRowList = $('.js-list-scroll')
  const $imageItemWrapper = $('.js-hscroll-images-item')
  const $clickToScrollBtn = $('.js-click-to-hscroll')
  const $imageRowItem = $('.js-list-scroll > div');
  const $scrollRight = $('.js-click-to-hscroll.scroll-right');
  const $scrollLeft = $('.js-click-to-hscroll.scroll-left');
  const spaceBetweenItems =  20;

  $scrollRight.addClass('visible');


  $imageRowList.on('scroll', function() {
    var currentPosition = $imageRowList.scrollLeft();
    var imageItemWidth = $imageItemWrapper.width();
    var nextPosition = currentPosition + imageItemWidth + spaceBetweenItems;

    if (window.innerWidth < 700) {
      if(currentPosition > 1) {
        $scrollLeft.addClass('visible');
        $scrollRight.addClass('visible');
      }
      else {
        $scrollLeft.removeClass('visible');
      }
      if($imageRowItem.last().position().left < imageItemWidth) {
        $scrollRight.removeClass('visible');
      }
      else {
        $scrollRight.addClass('visible');
      }
    }
    else {
      if (currentPosition > 1) {
        $scrollLeft.addClass('visible');
        $scrollRight.addClass('visible');
      }
      else {
        $scrollLeft.removeClass('visible');
      }

      if (nextPosition + imageItemWidth > $imageRowItem.last().position().left) {
        $scrollRight.removeClass('visible');
      }
      else {
        $scrollRight.addClass('visible');
      }
    }
  });

  $clickToScrollBtn.on('click', function() {
    var currentPosition = $imageRowList.scrollLeft();
    var $this = $(this);
    var imageItemWidth = $imageItemWrapper.width();
    var imageRowListWidth = $imageRowList.outerWidth();
    var imageRowListScrollWidth = $imageRowList.get(0).scrollWidth;
    var nextPosition = 0
    $scrollLeft.addClass('visible');

    if ($this.data('direction') === 'right') {
      if (imageRowListScrollWidth - currentPosition === imageRowListWidth) {
        $scrollLeft.removeClass('visible');
      	nextPosition = 0
      } else {
      	nextPosition = currentPosition + imageItemWidth + spaceBetweenItems;
      }
    } else {
      if (currentPosition === 0) {
        $scrollLeft.removeClass('visible');
      	nextPosition = imageRowListScrollWidth - imageRowListWidth
      } else {
      	nextPosition = currentPosition - imageItemWidth - spaceBetweenItems;
      }
    }

    $imageRowList.stop().animate({
      scrollLeft: nextPosition
    }, 800)

    setTimeout(function() {
      if (window.innerWidth < 1200) {
        if ($imageRowItem.last().position().left < imageItemWidth) {
          $scrollRight.removeClass('visible');
        }
        else {
          $scrollRight.addClass('visible');
        }
        if (nextPosition < 20) {
          $scrollLeft.removeClass('visible');
        }
        else {
          $ ('.js-click-to-hscroll.scroll-left').addClass('visible');
        }
      }
      else {
        if (nextPosition + imageItemWidth > $imageRowItem.last().position().left) {
          $scrollRight.removeClass('visible');
        }
        else {
          $scrollRight.addClass('visible');
        }
        if (nextPosition < 10) {
          $scrollLeft.removeClass('visible');
        }
      }
    }, 400)
  })
})();
